<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Centered -->
<centered-layout *ngIf="layout === 'centered'"></centered-layout>

<!-- Enterprise -->
<enterprise-layout *ngIf="layout === 'enterprise'"></enterprise-layout>

<!-- Material -->
<material-layout *ngIf="layout === 'material'"></material-layout>

<!-- Modern -->
<modern-layout *ngIf="layout === 'modern'"></modern-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Classic -->
<classic-layout *ngIf="layout === 'classic'"></classic-layout>

<!-- Classy -->
<classy-layout *ngIf="layout === 'classy'"></classy-layout>

<!-- Compact -->
<compact-layout *ngIf="layout === 'compact'"></compact-layout>

<!-- Dense -->
<dense-layout *ngIf="layout === 'dense'"></dense-layout>

<!-- Futuristic -->
<futuristic-layout *ngIf="layout === 'futuristic'"></futuristic-layout>

<!-- Thin -->
<thin-layout *ngIf="layout === 'thin'"></thin-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Settings drawer - Remove this to remove the drawer and its button -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- <settings></settings> -->
<!-- Alert Message -->
<fuse-alert
  class="fixed top-0 left-0 w-full flex justify-center items-center mt-8 alert-main z-99999"
  [type]="_alertConfig.type"
  [appearance]="'outline'"
  *ngIf="showAlert"
  [@fadeIn]="showAlert"
>
  {{ _alertConfig.message }}
</fuse-alert>

<!-- Side Panel (Drawer) for Alta Ticket -->
<fuse-drawer #ticketDrawer="fuseDrawer"
    class="bg-white shadow-[-25px_0_50px_rgba(0,0,0,0.25)] border-l border-gray-200 z-[999] !fixed !inset-y-0 !right-0 sm:!left-auto !w-[100vw] sm:!w-[560px] md:!w-[640px] !max-w-[100vw]"
    style="z-index: 999 !important;" [fixed]="true" [mode]="'over'" [name]="'ticketDrawer'" [opened]="false"
    [position]="'right'" [transparentOverlay]="true">
    <app-alta-ticket #altaTicketComp *ngIf="ticketDrawer.opened" [isDrawer]="true" class="flex flex-col w-full h-full overflow-hidden" (cerrado)="ticketDrawer.close()"></app-alta-ticket>
</fuse-drawer>
